import React, { FC } from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
    color: blue !important;
    font-weight: bold;
    font-size: 12px;
`;

/** will only render children components if `?debug'  is added to the url */
const Debug: FC = ({ children }) => {
    if (window.location.search !== '?debug')
        return null;

    return (
        <Container>
            {children}
        </Container>
    )
}

export default Debug
